function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

const SvgArticle = (_ref) => {
  let svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#546E7A"
    },
    d: "M 5 22 L 7 22 L 7 26 L 5 26 Z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#546E7A"
    },
    d: "M 41 22 L 43 22 L 43 26 L 41 26 Z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC107"
    },
    d: "M 40 19 L 8 19 L 8 39 C 8 41.210938 9.789063 43 12 43 L 36 43 C 38.210938 43 40 41.210938 40 39 Z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFECB3"
    },
    d: "M 36 31 L 12 31 L 12 29 C 12 29 12 28 13 28 C 14 28 34 28 35 28 C 36 28 36 29 36 29 Z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#37474F"
    },
    d: "M 10 19 L 10 20 C 10 21.105469 10.894531 22 12 22 L 36 22 C 37.105469 22 38 21.105469 38 20 L 38 19 Z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#37474F"
    },
    d: "M 28.617188 19 L 19.382813 19 C 17.925781 19.734375 17 20.804688 17 22 C 17 24.210938 20.132813 26 24 26 C 27.867188 26 31 24.210938 31 22 C 31 20.804688 30.074219 19.734375 28.617188 19 Z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#37474F"
    },
    d: "M 36 38 C 36 39.105469 35.105469 40 34 40 L 14 40 C 12.894531 40 12 39.105469 12 38 L 12 31 L 36 31 Z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#37474F"
    },
    d: "M 7 23 L 8 23 L 8 25 L 7 25 Z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#37474F"
    },
    d: "M 40 23 L 41 23 L 41 25 L 40 25 Z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#90CAF9"
    },
    d: "M 12 5 L 36 5 L 36 20 L 12 20 Z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#90CAF9"
    },
    d: "M 27 20.285156 C 27 19.335938 25.65625 18.570313 24 18.570313 C 22.34375 18.570313 21 19.335938 21 20.285156 C 21 21.230469 22.34375 22 24 22 C 25.65625 22 27 21.230469 27 20.285156 Z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1976D2"
    },
    d: "M 16 9 L 32 9 L 32 11 L 16 11 Z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1976D2"
    },
    d: "M 16 13 L 28 13 L 28 15 L 16 15 Z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B0BEC5"
    },
    d: "M 16 34 C 16 34.550781 15.550781 35 15 35 C 14.449219 35 14 34.550781 14 34 C 14 33.449219 14.449219 33 15 33 C 15.550781 33 16 33.449219 16 34 Z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B0BEC5"
    },
    d: "M 16 37 C 16 37.550781 15.550781 38 15 38 C 14.449219 38 14 37.550781 14 37 C 14 36.449219 14.449219 36 15 36 C 15.550781 36 16 36.449219 16 37 Z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B0BEC5"
    },
    d: "M 34 34 C 34 34.550781 33.550781 35 33 35 C 32.449219 35 32 34.550781 32 34 C 32 33.449219 32.449219 33 33 33 C 33.550781 33 34 33.449219 34 34 Z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B0BEC5"
    },
    d: "M 34 37 C 34 37.550781 33.550781 38 33 38 C 32.449219 38 32 37.550781 32 37 C 32 36.449219 32.449219 36 33 36 C 33.550781 36 34 36.449219 34 37 Z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B0BEC5"
    },
    d: "M 19 34 C 19 34.550781 18.550781 35 18 35 C 17.449219 35 17 34.550781 17 34 C 17 33.449219 17.449219 33 18 33 C 18.550781 33 19 33.449219 19 34 Z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B0BEC5"
    },
    d: "M 22 34 C 22 34.550781 21.550781 35 21 35 C 20.449219 35 20 34.550781 20 34 C 20 33.449219 20.449219 33 21 33 C 21.550781 33 22 33.449219 22 34 Z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B0BEC5"
    },
    d: "M 25 34 C 25 34.550781 24.550781 35 24 35 C 23.449219 35 23 34.550781 23 34 C 23 33.449219 23.449219 33 24 33 C 24.550781 33 25 33.449219 25 34 Z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B0BEC5"
    },
    d: "M 28 34 C 28 34.550781 27.550781 35 27 35 C 26.449219 35 26 34.550781 26 34 C 26 33.449219 26.449219 33 27 33 C 27.550781 33 28 33.449219 28 34 Z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B0BEC5"
    },
    d: "M 31 34 C 31 34.550781 30.550781 35 30 35 C 29.449219 35 29 34.550781 29 34 C 29 33.449219 29.449219 33 30 33 C 30.550781 33 31 33.449219 31 34 Z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B0BEC5"
    },
    d: "M 31 37 C 31 37.554688 30.554688 38 30 38 L 18 38 C 17.449219 38 17 37.554688 17 37 C 17 36.445313 17.449219 36 18 36 L 30 36 C 30.554688 36 31 36.445313 31 37 Z "
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgArticle, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/article.a64f7400.svg";
export { ForwardRef as ReactComponent };